import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import SignaturePad from 'signature_pad';
import {SignatureService} from '@app/services/signature.service';
import {MatDialog} from '@angular/material/dialog';
import {SignatureComponentDialogComponent} from '@app/dialogs/signature-component-dialog/signature-component-dialog.component';

@Component({
    selector: 'app-form-input-signature',
    templateUrl: './form-input-signature.component.html',
    styleUrls: ['./form-input-signature.component.scss'],
    standalone: false
})
export class FormInputSignatureComponent implements AfterViewInit {

    @ViewChild('signatureCanvas') canvasRef: ElementRef<HTMLCanvasElement>;

    @Input() control: AbstractControl;
    @Input() field: Field<string>;

    private pad: SignaturePad;

    constructor(private signatureService: SignatureService, private matDialog: MatDialog, private ref: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        this.pad = new SignaturePad(this.canvasRef.nativeElement, {minWidth: 1});

        if (this.field.value) {
            this.pad.fromDataURL(this.field.value);
        }
    }

    clear() {
        this.pad.clear();
        this.pad.on();
        this.control.setValue(null);
    }

    submit() {
        this.pad.off();
        this.control.setValue(this.pad.toDataURL());
    }

    refresh() {
        this.signatureService.refresh().subscribe((result) => {
            if (result.data.signature) {
                this.pad.fromDataURL(result.data.signature);
                this.control.setValue(result.data.signature);
            }
        });
    }

    openSignatureComponent() {
        const dialogRef = SignatureComponentDialogComponent.open(this.matDialog, this.field.fieldUuid, this.field.config.label);

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.pad.fromDataURL(result);
                this.pad.off();
                this.control.setValue(this.pad.toDataURL());
                this.ref.markForCheck();
            }
        });
    }
}
